'use strict';

wbApp.controller('SemesterCourseSummaryCtrl', ['$scope', '$timeout', '$translate', 'semesterSvc', 'securitySvc',
function ($scope, $timeout, $translate, semesterSvc, securitySvc) {

    if (!securitySvc.isInRole('Dashboard.SemesterCourse')) {
        return;
    }

    $scope.summary;
    var activeSemesterPromise = semesterSvc.getDefaultAsync();

    // Wait for active semester
    activeSemesterPromise.then(function (activeSemester) {
        if (activeSemester) {
            $scope.semesterID = activeSemester.id;
        } else {
            $scope.semesterID = null;
        }

        $scope.onSemesterChange($scope.semesterID);
    });

    $scope.chart = {
        type: 'PieChart', data: [
            ['Component', 'Value'],
            [$translate.instant('TXT_COL_ATTENDANCE_STATUS'), 0],
            [$translate.instant('TXT_STATUS_NOT_PRESENT_NOT_EXCUSED'), 0],
            [$translate.instant('TXT_STATUS_NOT_PRESENT_EXCUSED'), 0],
            [$translate.instant('TXT_STATUS_NOT_PRESENT_EXCUSED_NO_COMPENSATION'), 0]
        ], options: {
            displayExactValues: true,
            chartArea: { width: '100%', height: '70%' },
            legend: { position: 'bottom' },
        }
    };

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            $scope.summary = semesterSvc.getCourseSummaryAsync(semesterID);
            $scope.summary.$promise.then(function (data) {
                $timeout(function () {
                    $scope.chart.data[1][1] = data.statusPresent;
                    $scope.chart.data[2][1] = data.statusNotPresentNotExcused;
                    $scope.chart.data[3][1] = data.statusNotPresentExcused;
                    $scope.chart.data[4][1] = data.statusNotPresentExcusedNoCompensation;
                });
            });
        }
    }


    $scope.title = 'ABC';
}]);